import { Stack } from "@mui/system";
import PageScanRequestFilter from "./PageScanRequestFilter";
import { Autocomplete, Button, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import PageScanRequestModal from "../PageScanRequestModal/PageScanRequestModal";
import { useEffect, useState } from "react";
import SimpleBackdrop from "../../../../../BackDrop/BackDrop";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../../../features/userSlice";
import { useSearchParams } from "react-router-dom";
import { CheckPermissions } from "../../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { useDispatch } from "react-redux";
import { setAddNewPageReqText } from "../../../../../../features/pageSpeedPerformanceSlice";

interface Props {
  postPageSpeed: Function;
  errorAccToPageStatus: any;
  postedPageSpeedContent: any;
  setErrorAccToPageStatus: any;
  loaderForPageSpeed: any;
  rows: any;
  setSelectedSearchValue: any;
  selectedSearchValue: any;
}

function PageScanRequestFilterCard({
  selectedSearchValue,
  setSelectedSearchValue,
  rows,
  loaderForPageSpeed,
  setErrorAccToPageStatus,
  postedPageSpeedContent,
  errorAccToPageStatus,
  postPageSpeed,
}: Props) {
  // const [openModal, setOpenModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasCreatePsiResults = CheckPermissions(
    response?.data?.products?.assets,
    "health",
    "create_internal_psi_request"
  );
  const websitelisting = rows.map((row: any) => ({
    label: row.page_name,
  }));
  const [searchParams, setSearchParams] = useSearchParams();
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setErrorAccToPageStatus([]);
    dispatch(setAddNewPageReqText("")); // Clear the input field when modal is closed
  };

  useEffect(() => {
    setSelectedSearchValue(searchParams.get("search"));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Stack
        flexDirection={"row"}
        justifyContent={"start"}
        gap={4}
        sx={{ paddingBlock: "16px" }}
      >
        <Autocomplete
          data-tracker="161"
          sx={{ width: "300px" }}
          options={websitelisting.map((website: any) => website.label)}
          value={selectedSearchValue}
          onChange={(_, newValue) => {
            setSelectedSearchValue(newValue); // Update selectedSearchValue with the chosen option
            setSearchParams((prevParams) => {
              const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
              if (newValue) {
                updatedParams.search = newValue; // Set new value
              } else {
                delete updatedParams.search; // Remove from URL if cleared
              }
              // Also update page param in URL to reflect reset
              updatedParams.pageScanPage = "0";
              return updatedParams;
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Page Name or URL"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "12px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
          size="small"
          filterOptions={(options, { inputValue }) =>
            options.filter((option: any) =>
              option.toLowerCase().includes(inputValue.toLowerCase())
            )
          }
        />
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          sx={{ width: "100%" }}
        >
          {/* Page scan request filter */}

          <PageScanRequestFilter
            setSelectedSearchValue={setSelectedSearchValue}
            rows={rows}
          />
          {hasCreatePsiResults ? (
            <Button
              data-tracker="159"
              variant="contained"
              color="secondary"
              sx={{ whiteSpace: "nowrap" }}
              onClick={handleOpenModal}
            >
              Create new Request
              <AddIcon />
            </Button>
          ) : (
            <Button variant="contained" disabled sx={{ whiteSpace: "nowrap" }}>
              Create new Request
            </Button>
          )}
        </Stack>
      </Stack>
      <>
        {loaderForPageSpeed ? (
          <SimpleBackdrop />
        ) : (
          <PageScanRequestModal
            setErrorAccToPageStatus={setErrorAccToPageStatus}
            setOpenModal={setOpenModal}
            postedPageSpeedContent={postedPageSpeedContent}
            errorAccToPageStatus={errorAccToPageStatus}
            postPageSpeed={postPageSpeed}
            open={openModal}
            handleClose={handleCloseModal}
          />
        )}
      </>
    </>
  );
}

export default PageScanRequestFilterCard;
